/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AppCalendarRouteImport } from './routes/_app.calendar'
import { Route as AppDesignRouteImport } from './routes/_app.design'
import { Route as AppInboxRouteImport } from './routes/_app.inbox'
import { Route as AppNotificationsRouteImport } from './routes/_app.notifications'
import { Route as AppSearchRouteImport } from './routes/_app.search'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppTasksRouteImport } from './routes/_app.tasks'
import { Route as AppTodayRouteImport } from './routes/_app.today'
import { Route as AppTrashRouteImport } from './routes/_app.trash'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as Login2faRouteImport } from './routes/login_.2fa'
import { Route as AppEntriesIndexRouteImport } from './routes/_app.entries.index'
import { Route as AppEntriesEntryIdRouteImport } from './routes/_app.entries.$entryId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppSettingsApiKeysRouteImport } from './routes/_app.settings.api-keys'
import { Route as AppSettingsDesignRouteImport } from './routes/_app.settings.design'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app.settings.notifications'
import { Route as AppSettingsReadingRouteImport } from './routes/_app.settings.reading'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app.settings.security'
import { Route as AppSettingsTagsRouteImport } from './routes/_app.settings.tags'
import { Route as AppSettingsTemplatesRouteImport } from './routes/_app.settings.templates'
import { Route as AppSettingsThemeRouteImport } from './routes/_app.settings.theme'
import { Route as AppSettingsTypesRouteImport } from './routes/_app.settings.types'
import { Route as AppSpacesIndexRouteImport } from './routes/_app.spaces.index'
import { Route as AppSpacesSpaceSlugRouteImport } from './routes/_app.spaces.$spaceSlug'
import { Route as AppSettingsTemplatesTemplateIdRouteImport } from './routes/_app.settings.templates_.$templateId'
import { Route as AppSettingsTemplatesNewRouteImport } from './routes/_app.settings.templates_.new'
import { Route as AppSettingsWorkspaceIndexRouteImport } from './routes/_app.settings.workspace.index'
import { Route as AppSettingsWorkspaceAuditRouteImport } from './routes/_app.settings.workspace.audit'
import { Route as AppSettingsWorkspaceMembersRouteImport } from './routes/_app.settings.workspace.members'
import { Route as AppSettingsWorkspaceUsersRouteImport } from './routes/_app.settings.workspace.users'
import { Route as AppSpacesSpaceSlugEntriesRouteImport } from './routes/_app.spaces.$spaceSlug_.entries'
import { Route as AppSpacesSpaceSlugHomeRouteImport } from './routes/_app.spaces.$spaceSlug_.home'
import { Route as AppSpacesSpaceSlugTreeRouteImport } from './routes/_app.spaces.$spaceSlug_.tree'
import { Route as AppSpacesSpaceSlugTasksTaskIdRouteImport } from './routes/_app.spaces.$spaceSlug.tasks.$taskId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppDesignRoute = AppDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTodayRoute = AppTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const Login2faRoute = Login2faRouteImport.update({
  id: '/login_/2fa',
  path: '/login/2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const AppEntriesIndexRoute = AppEntriesIndexRouteImport.update({
  id: '/entries/',
  path: '/entries/',
  getParentRoute: () => AppRoute,
} as any)
const AppEntriesEntryIdRoute = AppEntriesEntryIdRouteImport.update({
  id: '/entries/$entryId',
  path: '/entries/$entryId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDesignRoute = AppSettingsDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsReadingRoute = AppSettingsReadingRouteImport.update({
  id: '/reading',
  path: '/reading',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTagsRoute = AppSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTemplatesRoute = AppSettingsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsThemeRoute = AppSettingsThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTypesRoute = AppSettingsTypesRouteImport.update({
  id: '/types',
  path: '/types',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSpacesIndexRoute = AppSpacesIndexRouteImport.update({
  id: '/spaces/',
  path: '/spaces/',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesSpaceSlugRoute = AppSpacesSpaceSlugRouteImport.update({
  id: '/spaces/$spaceSlug',
  path: '/spaces/$spaceSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTemplatesTemplateIdRoute =
  AppSettingsTemplatesTemplateIdRouteImport.update({
    id: '/templates_/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsTemplatesNewRoute = AppSettingsTemplatesNewRouteImport.update({
  id: '/templates_/new',
  path: '/templates/new',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsWorkspaceIndexRoute =
  AppSettingsWorkspaceIndexRouteImport.update({
    id: '/workspace/',
    path: '/workspace/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsWorkspaceAuditRoute =
  AppSettingsWorkspaceAuditRouteImport.update({
    id: '/workspace/audit',
    path: '/workspace/audit',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsWorkspaceMembersRoute =
  AppSettingsWorkspaceMembersRouteImport.update({
    id: '/workspace/members',
    path: '/workspace/members',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsWorkspaceUsersRoute =
  AppSettingsWorkspaceUsersRouteImport.update({
    id: '/workspace/users',
    path: '/workspace/users',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSpacesSpaceSlugEntriesRoute =
  AppSpacesSpaceSlugEntriesRouteImport.update({
    id: '/spaces/$spaceSlug_/entries',
    path: '/spaces/$spaceSlug/entries',
    getParentRoute: () => AppRoute,
  } as any)
const AppSpacesSpaceSlugHomeRoute = AppSpacesSpaceSlugHomeRouteImport.update({
  id: '/spaces/$spaceSlug_/home',
  path: '/spaces/$spaceSlug/home',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesSpaceSlugTreeRoute = AppSpacesSpaceSlugTreeRouteImport.update({
  id: '/spaces/$spaceSlug_/tree',
  path: '/spaces/$spaceSlug/tree',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesSpaceSlugTasksTaskIdRoute =
  AppSpacesSpaceSlugTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AppSpacesSpaceSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/calendar': typeof AppCalendarRoute
  '/design': typeof AppDesignRoute
  '/inbox': typeof AppInboxRoute
  '/notifications': typeof AppNotificationsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/tasks': typeof AppTasksRoute
  '/today': typeof AppTodayRoute
  '/trash': typeof AppTrashRoute
  '/invite/$token': typeof InviteTokenRoute
  '/login/2fa': typeof Login2faRoute
  '/entries/$entryId': typeof AppEntriesEntryIdRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/design': typeof AppSettingsDesignRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/reading': typeof AppSettingsReadingRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/settings/theme': typeof AppSettingsThemeRoute
  '/settings/types': typeof AppSettingsTypesRoute
  '/spaces/$spaceSlug': typeof AppSpacesSpaceSlugRouteWithChildren
  '/entries/': typeof AppEntriesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/spaces/': typeof AppSpacesIndexRoute
  '/settings/templates/$templateId': typeof AppSettingsTemplatesTemplateIdRoute
  '/settings/templates/new': typeof AppSettingsTemplatesNewRoute
  '/settings/workspace/audit': typeof AppSettingsWorkspaceAuditRoute
  '/settings/workspace/members': typeof AppSettingsWorkspaceMembersRoute
  '/settings/workspace/users': typeof AppSettingsWorkspaceUsersRoute
  '/spaces/$spaceSlug/entries': typeof AppSpacesSpaceSlugEntriesRoute
  '/spaces/$spaceSlug/home': typeof AppSpacesSpaceSlugHomeRoute
  '/spaces/$spaceSlug/tree': typeof AppSpacesSpaceSlugTreeRoute
  '/settings/workspace/': typeof AppSettingsWorkspaceIndexRoute
  '/spaces/$spaceSlug/tasks/$taskId': typeof AppSpacesSpaceSlugTasksTaskIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/calendar': typeof AppCalendarRoute
  '/design': typeof AppDesignRoute
  '/inbox': typeof AppInboxRoute
  '/notifications': typeof AppNotificationsRoute
  '/search': typeof AppSearchRoute
  '/tasks': typeof AppTasksRoute
  '/today': typeof AppTodayRoute
  '/trash': typeof AppTrashRoute
  '/invite/$token': typeof InviteTokenRoute
  '/login/2fa': typeof Login2faRoute
  '/entries/$entryId': typeof AppEntriesEntryIdRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/design': typeof AppSettingsDesignRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/reading': typeof AppSettingsReadingRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/settings/theme': typeof AppSettingsThemeRoute
  '/settings/types': typeof AppSettingsTypesRoute
  '/spaces/$spaceSlug': typeof AppSpacesSpaceSlugRouteWithChildren
  '/entries': typeof AppEntriesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/spaces': typeof AppSpacesIndexRoute
  '/settings/templates/$templateId': typeof AppSettingsTemplatesTemplateIdRoute
  '/settings/templates/new': typeof AppSettingsTemplatesNewRoute
  '/settings/workspace/audit': typeof AppSettingsWorkspaceAuditRoute
  '/settings/workspace/members': typeof AppSettingsWorkspaceMembersRoute
  '/settings/workspace/users': typeof AppSettingsWorkspaceUsersRoute
  '/spaces/$spaceSlug/entries': typeof AppSpacesSpaceSlugEntriesRoute
  '/spaces/$spaceSlug/home': typeof AppSpacesSpaceSlugHomeRoute
  '/spaces/$spaceSlug/tree': typeof AppSpacesSpaceSlugTreeRoute
  '/settings/workspace': typeof AppSettingsWorkspaceIndexRoute
  '/spaces/$spaceSlug/tasks/$taskId': typeof AppSpacesSpaceSlugTasksTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/design': typeof AppDesignRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/tasks': typeof AppTasksRoute
  '/_app/today': typeof AppTodayRoute
  '/_app/trash': typeof AppTrashRoute
  '/invite/$token': typeof InviteTokenRoute
  '/login_/2fa': typeof Login2faRoute
  '/_app/entries/$entryId': typeof AppEntriesEntryIdRoute
  '/_app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/_app/settings/design': typeof AppSettingsDesignRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/reading': typeof AppSettingsReadingRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/tags': typeof AppSettingsTagsRoute
  '/_app/settings/templates': typeof AppSettingsTemplatesRoute
  '/_app/settings/theme': typeof AppSettingsThemeRoute
  '/_app/settings/types': typeof AppSettingsTypesRoute
  '/_app/spaces/$spaceSlug': typeof AppSpacesSpaceSlugRouteWithChildren
  '/_app/entries/': typeof AppEntriesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/spaces/': typeof AppSpacesIndexRoute
  '/_app/settings/templates_/$templateId': typeof AppSettingsTemplatesTemplateIdRoute
  '/_app/settings/templates_/new': typeof AppSettingsTemplatesNewRoute
  '/_app/settings/workspace/audit': typeof AppSettingsWorkspaceAuditRoute
  '/_app/settings/workspace/members': typeof AppSettingsWorkspaceMembersRoute
  '/_app/settings/workspace/users': typeof AppSettingsWorkspaceUsersRoute
  '/_app/spaces/$spaceSlug_/entries': typeof AppSpacesSpaceSlugEntriesRoute
  '/_app/spaces/$spaceSlug_/home': typeof AppSpacesSpaceSlugHomeRoute
  '/_app/spaces/$spaceSlug_/tree': typeof AppSpacesSpaceSlugTreeRoute
  '/_app/settings/workspace/': typeof AppSettingsWorkspaceIndexRoute
  '/_app/spaces/$spaceSlug/tasks/$taskId': typeof AppSpacesSpaceSlugTasksTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/calendar'
    | '/design'
    | '/inbox'
    | '/notifications'
    | '/search'
    | '/settings'
    | '/tasks'
    | '/today'
    | '/trash'
    | '/invite/$token'
    | '/login/2fa'
    | '/entries/$entryId'
    | '/settings/api-keys'
    | '/settings/design'
    | '/settings/notifications'
    | '/settings/reading'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/templates'
    | '/settings/theme'
    | '/settings/types'
    | '/spaces/$spaceSlug'
    | '/entries/'
    | '/settings/'
    | '/spaces/'
    | '/settings/templates/$templateId'
    | '/settings/templates/new'
    | '/settings/workspace/audit'
    | '/settings/workspace/members'
    | '/settings/workspace/users'
    | '/spaces/$spaceSlug/entries'
    | '/spaces/$spaceSlug/home'
    | '/spaces/$spaceSlug/tree'
    | '/settings/workspace/'
    | '/spaces/$spaceSlug/tasks/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/calendar'
    | '/design'
    | '/inbox'
    | '/notifications'
    | '/search'
    | '/tasks'
    | '/today'
    | '/trash'
    | '/invite/$token'
    | '/login/2fa'
    | '/entries/$entryId'
    | '/settings/api-keys'
    | '/settings/design'
    | '/settings/notifications'
    | '/settings/reading'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/templates'
    | '/settings/theme'
    | '/settings/types'
    | '/spaces/$spaceSlug'
    | '/entries'
    | '/settings'
    | '/spaces'
    | '/settings/templates/$templateId'
    | '/settings/templates/new'
    | '/settings/workspace/audit'
    | '/settings/workspace/members'
    | '/settings/workspace/users'
    | '/spaces/$spaceSlug/entries'
    | '/spaces/$spaceSlug/home'
    | '/spaces/$spaceSlug/tree'
    | '/settings/workspace'
    | '/spaces/$spaceSlug/tasks/$taskId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/register'
    | '/_app/calendar'
    | '/_app/design'
    | '/_app/inbox'
    | '/_app/notifications'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/today'
    | '/_app/trash'
    | '/invite/$token'
    | '/login_/2fa'
    | '/_app/entries/$entryId'
    | '/_app/settings/api-keys'
    | '/_app/settings/design'
    | '/_app/settings/notifications'
    | '/_app/settings/reading'
    | '/_app/settings/security'
    | '/_app/settings/tags'
    | '/_app/settings/templates'
    | '/_app/settings/theme'
    | '/_app/settings/types'
    | '/_app/spaces/$spaceSlug'
    | '/_app/entries/'
    | '/_app/settings/'
    | '/_app/spaces/'
    | '/_app/settings/templates_/$templateId'
    | '/_app/settings/templates_/new'
    | '/_app/settings/workspace/audit'
    | '/_app/settings/workspace/members'
    | '/_app/settings/workspace/users'
    | '/_app/spaces/$spaceSlug_/entries'
    | '/_app/spaces/$spaceSlug_/home'
    | '/_app/spaces/$spaceSlug_/tree'
    | '/_app/settings/workspace/'
    | '/_app/spaces/$spaceSlug/tasks/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  InviteTokenRoute: typeof InviteTokenRoute
  Login2faRoute: typeof Login2faRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/design': {
      id: '/_app/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof AppDesignRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/today': {
      id: '/_app/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AppTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/2fa': {
      id: '/login_/2fa'
      path: '/login/2fa'
      fullPath: '/login/2fa'
      preLoaderRoute: typeof Login2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/entries/': {
      id: '/_app/entries/'
      path: '/entries'
      fullPath: '/entries/'
      preLoaderRoute: typeof AppEntriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entries/$entryId': {
      id: '/_app/entries/$entryId'
      path: '/entries/$entryId'
      fullPath: '/entries/$entryId'
      preLoaderRoute: typeof AppEntriesEntryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/api-keys': {
      id: '/_app/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/design': {
      id: '/_app/settings/design'
      path: '/design'
      fullPath: '/settings/design'
      preLoaderRoute: typeof AppSettingsDesignRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/reading': {
      id: '/_app/settings/reading'
      path: '/reading'
      fullPath: '/settings/reading'
      preLoaderRoute: typeof AppSettingsReadingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tags': {
      id: '/_app/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AppSettingsTagsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/templates': {
      id: '/_app/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof AppSettingsTemplatesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/theme': {
      id: '/_app/settings/theme'
      path: '/theme'
      fullPath: '/settings/theme'
      preLoaderRoute: typeof AppSettingsThemeRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/types': {
      id: '/_app/settings/types'
      path: '/types'
      fullPath: '/settings/types'
      preLoaderRoute: typeof AppSettingsTypesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/spaces/': {
      id: '/_app/spaces/'
      path: '/spaces'
      fullPath: '/spaces/'
      preLoaderRoute: typeof AppSpacesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/$spaceSlug': {
      id: '/_app/spaces/$spaceSlug'
      path: '/spaces/$spaceSlug'
      fullPath: '/spaces/$spaceSlug'
      preLoaderRoute: typeof AppSpacesSpaceSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/templates_/$templateId': {
      id: '/_app/settings/templates_/$templateId'
      path: '/templates/$templateId'
      fullPath: '/settings/templates/$templateId'
      preLoaderRoute: typeof AppSettingsTemplatesTemplateIdRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/templates_/new': {
      id: '/_app/settings/templates_/new'
      path: '/templates/new'
      fullPath: '/settings/templates/new'
      preLoaderRoute: typeof AppSettingsTemplatesNewRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/workspace/': {
      id: '/_app/settings/workspace/'
      path: '/workspace'
      fullPath: '/settings/workspace/'
      preLoaderRoute: typeof AppSettingsWorkspaceIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/workspace/audit': {
      id: '/_app/settings/workspace/audit'
      path: '/workspace/audit'
      fullPath: '/settings/workspace/audit'
      preLoaderRoute: typeof AppSettingsWorkspaceAuditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/workspace/members': {
      id: '/_app/settings/workspace/members'
      path: '/workspace/members'
      fullPath: '/settings/workspace/members'
      preLoaderRoute: typeof AppSettingsWorkspaceMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/workspace/users': {
      id: '/_app/settings/workspace/users'
      path: '/workspace/users'
      fullPath: '/settings/workspace/users'
      preLoaderRoute: typeof AppSettingsWorkspaceUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/spaces/$spaceSlug_/entries': {
      id: '/_app/spaces/$spaceSlug_/entries'
      path: '/spaces/$spaceSlug/entries'
      fullPath: '/spaces/$spaceSlug/entries'
      preLoaderRoute: typeof AppSpacesSpaceSlugEntriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/$spaceSlug_/home': {
      id: '/_app/spaces/$spaceSlug_/home'
      path: '/spaces/$spaceSlug/home'
      fullPath: '/spaces/$spaceSlug/home'
      preLoaderRoute: typeof AppSpacesSpaceSlugHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/$spaceSlug_/tree': {
      id: '/_app/spaces/$spaceSlug_/tree'
      path: '/spaces/$spaceSlug/tree'
      fullPath: '/spaces/$spaceSlug/tree'
      preLoaderRoute: typeof AppSpacesSpaceSlugTreeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/$spaceSlug/tasks/$taskId': {
      id: '/_app/spaces/$spaceSlug/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/spaces/$spaceSlug/tasks/$taskId'
      preLoaderRoute: typeof AppSpacesSpaceSlugTasksTaskIdRouteImport
      parentRoute: typeof AppSpacesSpaceSlugRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsDesignRoute: typeof AppSettingsDesignRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsReadingRoute: typeof AppSettingsReadingRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTagsRoute: typeof AppSettingsTagsRoute
  AppSettingsTemplatesRoute: typeof AppSettingsTemplatesRoute
  AppSettingsThemeRoute: typeof AppSettingsThemeRoute
  AppSettingsTypesRoute: typeof AppSettingsTypesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsTemplatesTemplateIdRoute: typeof AppSettingsTemplatesTemplateIdRoute
  AppSettingsTemplatesNewRoute: typeof AppSettingsTemplatesNewRoute
  AppSettingsWorkspaceAuditRoute: typeof AppSettingsWorkspaceAuditRoute
  AppSettingsWorkspaceMembersRoute: typeof AppSettingsWorkspaceMembersRoute
  AppSettingsWorkspaceUsersRoute: typeof AppSettingsWorkspaceUsersRoute
  AppSettingsWorkspaceIndexRoute: typeof AppSettingsWorkspaceIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsDesignRoute: AppSettingsDesignRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsReadingRoute: AppSettingsReadingRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTagsRoute: AppSettingsTagsRoute,
  AppSettingsTemplatesRoute: AppSettingsTemplatesRoute,
  AppSettingsThemeRoute: AppSettingsThemeRoute,
  AppSettingsTypesRoute: AppSettingsTypesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsTemplatesTemplateIdRoute: AppSettingsTemplatesTemplateIdRoute,
  AppSettingsTemplatesNewRoute: AppSettingsTemplatesNewRoute,
  AppSettingsWorkspaceAuditRoute: AppSettingsWorkspaceAuditRoute,
  AppSettingsWorkspaceMembersRoute: AppSettingsWorkspaceMembersRoute,
  AppSettingsWorkspaceUsersRoute: AppSettingsWorkspaceUsersRoute,
  AppSettingsWorkspaceIndexRoute: AppSettingsWorkspaceIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppSpacesSpaceSlugRouteChildren {
  AppSpacesSpaceSlugTasksTaskIdRoute: typeof AppSpacesSpaceSlugTasksTaskIdRoute
}

const AppSpacesSpaceSlugRouteChildren: AppSpacesSpaceSlugRouteChildren = {
  AppSpacesSpaceSlugTasksTaskIdRoute: AppSpacesSpaceSlugTasksTaskIdRoute,
}

const AppSpacesSpaceSlugRouteWithChildren =
  AppSpacesSpaceSlugRoute._addFileChildren(AppSpacesSpaceSlugRouteChildren)

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute
  AppDesignRoute: typeof AppDesignRoute
  AppInboxRoute: typeof AppInboxRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTasksRoute: typeof AppTasksRoute
  AppTodayRoute: typeof AppTodayRoute
  AppTrashRoute: typeof AppTrashRoute
  AppEntriesEntryIdRoute: typeof AppEntriesEntryIdRoute
  AppSpacesSpaceSlugRoute: typeof AppSpacesSpaceSlugRouteWithChildren
  AppEntriesIndexRoute: typeof AppEntriesIndexRoute
  AppSpacesIndexRoute: typeof AppSpacesIndexRoute
  AppSpacesSpaceSlugEntriesRoute: typeof AppSpacesSpaceSlugEntriesRoute
  AppSpacesSpaceSlugHomeRoute: typeof AppSpacesSpaceSlugHomeRoute
  AppSpacesSpaceSlugTreeRoute: typeof AppSpacesSpaceSlugTreeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppDesignRoute: AppDesignRoute,
  AppInboxRoute: AppInboxRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTasksRoute: AppTasksRoute,
  AppTodayRoute: AppTodayRoute,
  AppTrashRoute: AppTrashRoute,
  AppEntriesEntryIdRoute: AppEntriesEntryIdRoute,
  AppSpacesSpaceSlugRoute: AppSpacesSpaceSlugRouteWithChildren,
  AppEntriesIndexRoute: AppEntriesIndexRoute,
  AppSpacesIndexRoute: AppSpacesIndexRoute,
  AppSpacesSpaceSlugEntriesRoute: AppSpacesSpaceSlugEntriesRoute,
  AppSpacesSpaceSlugHomeRoute: AppSpacesSpaceSlugHomeRoute,
  AppSpacesSpaceSlugTreeRoute: AppSpacesSpaceSlugTreeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  InviteTokenRoute: InviteTokenRoute,
  Login2faRoute: Login2faRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
